import { motion } from "framer-motion"
import { FiPause, FiPlay, FiVolume, FiVolume2 } from "react-icons/fi"

export const ControlsVideos = ({ isPlayed, isMuted, setIsPlayed, setIsMuted, isShow=true }) => {

    const handleClickPlayed = () => {
        return setIsPlayed(!isPlayed)
    }

    const handleClickMuted = () => {
        return setIsMuted(!isMuted)
    }

    const buttonAnimated = {
        whileHover:{scale:.945},
        whileTap:{scale:1.045}
    }

    const styleButton = "h-10 w-10 flex items-center justify-center border border-slate-300 rounded-full text-lg text-slate-300"

    return (
        <ul className={`${isShow ? "flex" : "hidden"} flex items-center gap-4`}>
            <li>
                <motion.button whileHover={buttonAnimated.whileHover} whileTap={buttonAnimated.whileHover} className={`${styleButton}`} onClick={ handleClickPlayed }>
                    { isPlayed ? <FiPlay/> : <FiPause />}
                </motion.button>
            </li>
            <li>
                <motion.button whileHover={buttonAnimated.whileHover} whileTap={buttonAnimated.whileHover} className={`${styleButton}`} onClick={ handleClickMuted }>
                    { isMuted ? <FiVolume /> :  <FiVolume2/> }
                </motion.button>
            </li>
        </ul>
    )
}